<template>
    <v-dialog :loading="loading" v-model="localdialog" content-class="courseapplyDialog" @click:outside="closeDialog" :fullscreen="$vuetify.breakpoint.smAndDown" width="600px">
        <v-card class="p-5" flat>
            <v-card-title>Request information for {{course.title}}<v-spacer></v-spacer><v-icon @click="closeDialog" color="primary">mdi-close</v-icon></v-card-title>
            <v-card-text>
              <v-container>
                <v-form ref="applyref" lazy-validation class="p-5" @submit.prevent="apply" >

                    <v-text-field validate-on-blur v-model="application.name" :error-messages="applicationErrors.name" label="Name" type="text" required="true"></v-text-field>
                    <v-text-field validate-on-blur :rules="emailRules" v-model="application.email" :error-messages="applicationErrors.email" label="Email" type="email" required="true"></v-text-field>
                </v-form>   
              </v-container>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn @click="apply" color="primary" :disabled="!application.email"><v-icon class="mr-3">mdi-send</v-icon>Contact the college</v-btn>
            </v-card-actions>
        </v-card>  
    </v-dialog>
</template>
<script>
import UserFiles from '@/Shared/UserFiles'
export default {
  props: {
    user: Object,
    errors: Object,
    state: String,
    dialog: Boolean,
    course: Object,
    baseurl: String,
  },
  components: {
      UserFiles
    },
  data() {
    return {
        localdialog: this.dialog,
        application: this.$inertia.form({
            name: (this.user.first_name || this.user.last_name) ? this.user.first_name + ' ' + this.user.last_name : '',
            email: this.user.email,
            course_id: this.course.id
        }),
        
        applicationErrors: {
          email: null,
          name: null
        },
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        loading:false
    }
  },
  computed: {
    
  },
  watch: {
    dialog: {
        handler () {
          this.localdialog = this.dialog
        },
        deep: true,
      },
   
    },
  methods: {
    selectFile(f) {
        console.log('file selected',f)
        if (f)
          this.application.file_id = f.id
        else
          this.application.file_id = null
    },
    apply() {
        this.loading = true;
        this.application.post(this.baseurl+'/course/apply', {
        onSuccess: (res) => {
            console.log('success!')
            this.loading=false
            this.$emit('applysuccess',this.course)
        },
        onError: (res) => {
            this.applicationErrors.email = (res && res.email) ? res.email : ''
            this.applicationErrors.name = (res && res.name) ? res.name : ''
            this.applicationErrors.course_id = (res && res.course_id) ? res.course_id : ''
            this.loading=false
        },
      })
    },
    closeDialog() {
      this.$emit('close');
    },

    getErrors(s) {
      if (this.errors)
        console.log('get errors',s,this.errors,this.errors[s])
        if (this.errors && this.errors[s])
            return this.errors[s]
        else
            return ""
    }
  }
  
}
</script>